import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { STUDIO_CTA_LABEL, STUDIO_SIGNUP_URL, STUDIO_TRIAL_SHORT } from '@/content/studio'
import { trackEvent } from '@/lib/analytics/load'
import { cn } from '@/lib/cn'

/*
 * /studio on phones: once the hero demo has scrolled away, a slim bar at the bottom
 * keeps the main action in reach. It steps aside while the pricing card or
 * the closing band (which carry the same button) are on screen. Hidden from
 * `md` up, where the Studio header stays pinned instead.
 */
export function StudioStickyCta() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Looked up on every check, not once: the page body renders after the chrome mounts.
    let frame = 0
    const check = () => {
      frame = 0
      const h = window.innerHeight
      // once the hero demo has scrolled up past the bottom of the screen, so the bar never sits on it
      const demo = document.getElementById('demo')
      const past = demo ? demo.getBoundingClientRect().bottom < h * 0.6 : window.scrollY > h * 0.9
      const covered = Array.from(document.querySelectorAll('#pricing, #get-started, footer')).some((el) => {
        const r = el.getBoundingClientRect()
        return r.top < h && r.bottom > 0
      })
      setShow(past && !covered)
    }
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(check)
    }
    check()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [])

  return (
    <div
      aria-hidden={!show}
      className={cn(
        'fixed inset-x-0 bottom-0 z-40 border-0 border-t border-solid border-white/10 bg-neutral-900 px-4 pb-4 pt-3 transition-transform duration-300 md:hidden',
        show ? 'translate-y-0' : 'pointer-events-none translate-y-full',
      )}
    >
      <Button
        asChild
        variant="primary"
        className="w-full justify-center"
        onClick={() => trackEvent('cta_click', { placement: 'bottom-bar', label: STUDIO_CTA_LABEL })}
      >
        <a href={STUDIO_SIGNUP_URL} tabIndex={show ? 0 : -1}>
          {STUDIO_CTA_LABEL}
        </a>
      </Button>
      <p className="m-0 mt-2 text-center text-small text-dark-blue-50">{STUDIO_TRIAL_SHORT}</p>
    </div>
  )
}
